export const getRedeemLabel = (redeemed, supply_limit) => {
    return `${redeemed}${supply_limit ? ` / ${supply_limit}` : ''}  redeemed`;
  };
  